import { render, staticRenderFns } from "./ManufacturingSettings.vue?vue&type=template&id=37ef596d&"
import script from "./ManufacturingSettings.vue?vue&type=script&lang=js&"
export * from "./ManufacturingSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports